import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { testimonials } from '../../mocks/testimonials';

const overallStats = [
  { label: 'Happy Travellers', value: '20,000+', icon: 'ri-user-smile-line' },
  { label: 'Average Rating', value: '4.9 / 5', icon: 'ri-star-fill' },
  { label: 'Total Reviews', value: '3,200+', icon: 'ri-chat-3-line' },
  { label: 'Years Trusted', value: '20 Years', icon: 'ri-award-line' },
];

export default function TestimonialsPage() {
  return (
    <div>
      <Navbar />

      {/* Hero */}
      <section className="relative h-80 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/56b91e2c3459354dce0053218e9ad41a.jpg"
          alt="Testimonials"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-emerald-900/72"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 pt-20">
          <p className="text-amber-400 text-sm font-semibold uppercase tracking-widest mb-3">Real Stories</p>
          <h1 className="text-4xl md:text-5xl font-bold text-white font-playfair">What Our Travellers Say</h1>
          <p className="text-white/75 mt-3 text-base max-w-xl">
            Hear directly from our happy travellers — their experiences inspire us every single day.
          </p>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-emerald-800 py-10">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {overallStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center text-amber-400 mx-auto mb-2">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <p className="text-3xl font-bold text-white font-playfair">{stat.value}</p>
              <p className="text-emerald-200/80 text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Featured Testimonial */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-10">
            <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-3">Featured Review</p>
            <h2 className="text-3xl font-bold text-gray-900 font-playfair">Traveller of the Month</h2>
          </div>
          <div className="bg-gradient-to-br from-emerald-50 to-amber-50 rounded-2xl p-10 border border-emerald-100 relative">
            <div className="text-emerald-200 text-8xl font-serif absolute top-4 left-8 leading-none">&ldquo;</div>
            <div className="relative z-10">
              <div className="flex items-center gap-1 mb-5 justify-center">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-base"></i>
                  </div>
                ))}
              </div>
              <p className="text-gray-700 text-lg leading-relaxed text-center mb-8 italic">
                &ldquo;{testimonials[0].comment}&rdquo;
              </p>
              <div className="flex items-center justify-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0 border-2 border-emerald-200">
                  <img src={testimonials[0].avatar} alt={testimonials[0].name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-bold text-gray-900 font-playfair">{testimonials[0].name}</p>
                  <p className="text-gray-500 text-sm">{testimonials[0].location} &middot; {testimonials[0].date}</p>
                  <p className="text-emerald-600 text-xs font-medium mt-0.5">{testimonials[0].tour}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All Reviews */}
      <section className="py-14 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 font-playfair">All Reviews</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {testimonials.map((t) => (
              <div key={t.id} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-emerald-200 transition-all duration-300">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className={`ri-star-${i < t.rating ? 'fill' : 'line'} text-amber-400 text-sm`}></i>
                      </div>
                    ))}
                  </div>
                  <span className="text-gray-400 text-xs">{t.date}</span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  &ldquo;{t.comment}&rdquo;
                </p>
                <div className="bg-emerald-50 rounded-lg px-3 py-2 mb-4">
                  <p className="text-emerald-700 text-xs font-medium">
                    <i className="ri-map-pin-line mr-1"></i>Tour: {t.tour}
                  </p>
                </div>
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">{t.name}</p>
                    <p className="text-gray-400 text-xs">{t.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-emerald-700">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white font-playfair mb-4">
            Ready to Create Your Own Story?
          </h2>
          <p className="text-emerald-100 mb-8">
            Join thousands of satisfied travellers who have trusted Arus Travel to craft their perfect holiday. Your adventure begins with a single call.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>Book Your Trip Today
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
